import React from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';

import { NavManager } from 'inside-out/managers/navManager';
import { AuthManager } from 'inside-out/managers/authManager';

import { Link, navigateTo } from 'inside-out/components/shared/link';
import logo from 'inside-out/images/logo.svg';
import logoMobile from 'inside-out/images/logo-mobile.svg';
import HamburgerIcon from 'inside-out/images/hamburger-icon.svg';
import CogGreyIcon from 'inside-out/images/cog-grey-icon.svg';
import BookmarkIcon from 'inside-out/images/bookmark-drop-down-icon.svg';

import * as LOGGED_IN_USER from './loggedInUser.graphql';
import {
	wrapperStyle,
	innerWrapperStyle,
	leftStyle,
	headerLinksStyle,
	headerLinkStyle,
	headerMenuLinkStyle,
	submenuStyle,
	rightStyle,
	logoStyle,
	riskButtonStyle,
	myAccountDropDowWrapperStyle,
	myAccountDropDownStyle,
	errorStyle,
} from './header.styles';

export class Header extends React.PureComponent {
	static propTypes = {
		navLinks: PropTypes.arrayOf(
			PropTypes.shape({
				to: PropTypes.string.isRequired,
				text: PropTypes.string,
				submenu: PropTypes.arrayOf(
					PropTypes.shape({
						to: PropTypes.string.isRequired,
						text: PropTypes.string.isRequired,
					})
				),
			})
		),
		topMargin: PropTypes.number.isRequired,
	};

	state = {
		isLoggedIn: AuthManager.sharedInstance.isLoggedIn,
	};

	loggedInDidChange = () => {
		this.setState({ isLoggedIn: AuthManager.sharedInstance.isLoggedIn });
	};

	componentWillMount() {
		AuthManager.sharedInstance.subscribe(this.loggedInDidChange);
	}

	componentWillUnmount() {
		AuthManager.sharedInstance.unsubscribe(this.loggedInDidChange);
	}

	renderRightCallToAction = ({ loading, error, data }) => {
		const { isLoggedIn } = this.state;
		

		if (isLoggedIn && loading) {
			return (
				<span id="header-right">
					<p>Loading...</p>
				</span>
			);
		}
		
		if (data && data.user) {
			const { user } = data;
			return (
				<div className={myAccountDropDowWrapperStyle}>
					<Link to="/my-account" tabIndex="0">
						{user.avatar && (
							<div>
								<div>
									<img src={user.avatar} alt="Avatar" />
								</div>
							</div>
						)}
						<div>My Account</div>
					</Link>

					<div className={myAccountDropDownStyle}>
						<Link to="/my-bookmarks">
							<span>
								<img src={BookmarkIcon} alt="" />
							</span>{' '}
							Bookmarks
						</Link>
						<Link to="/my-account">
							<span>
								<img src={CogGreyIcon} alt="" />
							</span>{' '}
							Account Settings
						</Link>
						<a onClick={AuthManager.sharedInstance.logout}>Log out</a>
					</div>
				</div>
			);
		} else {
			return (
				<span id="header-right">
					<Link to="/log-in">Log in</Link>
					<button className={riskButtonStyle} onClick={() => navigateTo('/screener')}>
						Are you at risk?
					</button>
				</span>
			);
		}
	};

	clearMenuFocus = e => {
		e.target.blur();
		console.log(e.currentTarget);
		e.currentTarget.style.pointerEvents = 'none';
		e.currentTarget.style.pointerEvents = 'auto';
	}

	render() {
		const { navLinks, topMargin } = this.props;

		return (
			<Query query={LOGGED_IN_USER}>
				{({ loading, error, data }) => {

					// If the client browser tries to login using the old cookie, log them out. 
					if (error) {
						AuthManager.sharedInstance.logout();
					}
					return (
						<div data-component="Header" className={wrapperStyle(topMargin)}>
							<nav className={innerWrapperStyle}>
								<span className={leftStyle}>
									<Link to="/" className={logoStyle}>
										<img
											id="logoDesktop"
											src={logo}
											alt="Inside Out : Institute for Eating Disorders"
										/>
										<img
											id="logoMobile"
											src={logoMobile}
											alt="Inside Out : Institute for Eating Disorders"
										/>
									</Link>
									<nav className={headerLinksStyle}>
										{navLinks &&
											navLinks.map((link, i) => (
												typeof link.to === 'string' && link.to !== ''
												? <Link className={headerLinkStyle(46)} key={i} to={link.to}>
														{link.text}
													</Link>
												: <div className={headerMenuLinkStyle} key={i} tabIndex="0" aria-haspopup="true" onClick={this.clearMenuFocus}>
														{link.text}
														{link.children &&
															<div className={submenuStyle} aria-label="submenu">
																{link.children.map(sublink=>(
																	<Link className={headerLinkStyle(40)} key={sublink.to} to={sublink.to}>
																		{sublink.text}
																	</Link>
																))}
															</div>
														}
													</div>
											))}
									</nav>
								</span>
								<span className={rightStyle}>
									{this.renderRightCallToAction({ loading, error, data })}
									<span id="hamburger" onClick={NavManager.showNavigation}>
										<img src={HamburgerIcon} alt="Navigation" />
									</span>
								</span>
							</nav>
						</div>
					);
				}}
			</Query>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/shared/header/header.component.js